import Vue from 'vue'
import Vuex from 'vuex'
import router from './routes/index'
import { i18n } from './lang'
import { logUserAction } from './utils/logging'
Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    baseData: {},
    postLogin: null,
    wftkn: '',
    api: '',
    logins: [],
    title1: '',
    fields: '',
    textColor: '#000',
    preError: false,
    preErrorPayload: {},
    isRejeted: false,
    welcomeBack: false,
    welcomeBackPayload: {},
    connecting: false,
    freeOver: false,
    plans: [],
    lastPostMessage: '',
    skipToFreeWifi: false,
    plumeLoginErrorMessage: '',
    isPlume: false,
    consentAgreed: undefined,
  },
  mutations: {
    skipToFreeWifi(state) {
      state.skipToFreeWifi = true
    },
    setBaseData(state, data) {
      state.baseData = data
    },
    clearBaseData(state) {
      state.baseData = {}
    },
    setPostLogin(state, data) {
      state.postLogin = data
    },
    setPlumeLoginError(state, data) {
      state.plumeLoginErrorMessage = data
    },
    setWftkn(state, data) {
      state.wftkn = data
    },
    setApi(state, data) {
      state.api = data
    },
    setLogins(state, data) {
      state.logins = data
    },
    setTitle1(state, data) {
      state.title1 = data
    },
    setFields(state, data) {
      state.fields = data
    },
    setTextColor(state, data) {
      state.textColor = data
    },
    setPreError(state, data) {
      state.preError = data
    },
    setPreErrorPayload(state, data) {
      state.preErrorPayload = data
    },
    setIsRejeted(state, data) {
      state.isRejeted = data
    },
    setWelcomeBackPayload(state, data) {
      state.welcomeBackPayload = data
    },
    setWelcomeBack(state, data) {
      state.welcomeBack = data
    },
    setConnecting(state, data) {
      state.connecting = data
    },
    setFreeOver(state, data) {
      state.freeOver = data
    },
    setPaymentPlans(state, data) {
      state.plans = data
    },
    setLastPostMessage(state, data) {
      state.lastPostMessage = data
    },
    setIsPlume(state, data) {
      state.isPlume = data
    },
    setAttemptCount(state, data) {
      state.attemptCount = data
    },
  },
  getters: {
    postLogin: (state) => {
      return state.postLogin
    },
    isPlume: (state) => {
      return state.isPlume
    },
    isConsentAgreed: (state) => {
      return state.consentAgreed
    },
  },
  actions: {
    fetchPostLogin(context, wftkn) {
      logUserAction({
        type: 'api_request',
        label: 'Post Login API Request',
        data: { wftkn }
      });

      axios
        .get(`/index.php?controller=landingpage&action=post-login-payload&wftkn=${wftkn}`)
        .then((res) => {
          context.commit('setPostLogin', res.data)

          logUserAction({
            type: 'navigation',
            label: 'Redirect to thankyou page to handle the remaining part'
          });
          router.push('thankyou')
        })
    },
    async fetchPlumeLogin(context, data) {
      const attemptCount = context.state.attemptCount || 1
      logUserAction({
        type: 'api_request',
        label: 'Plume Login API Request',
        data: { attemptCount, url: data.url }
      });

      try {
        await axios.get(
          `/?controller=proxy-request&action=fetchPlumeLogin&url=${data.url}&body=${JSON.stringify(
            data.body,
          )}`,
        )
        logUserAction({
          type: 'navigation',
          label: 'Plume Login Successful - Redirecting User'
        });
        window.location = data.redirect_url
      } catch (error) {
        logUserAction({
          type: 'error',
          label: 'Plume Login Failed',
          data: {
            error: error.message,
            status: error.response?.status,
            attemptCount
          }
        });

        console.log('~~~ [STORE] Proxy request failed', error)
        if (error.response && error.response.data && error.response.status === 400) {
          context.commit('setPlumeLoginError', 'request_failed__action_undefined')
        } else if (error.response && error.response.status === 417 && attemptCount < 2) {
          context.commit('setPlumeLoginError', error.response.data.meta)
          context.commit('setAttemptCount', attemptCount + 1)
          setTimeout(() => {
            context.dispatch('fetchPlumeLogin', data)
          }, 3000)
        } else if (error.response && error.response.status === 417 && attemptCount >= 2) {
          logUserAction({
            type: 'navigation',
            label: 'Redirecting to Retry Connection Page'
          });
          router.push('/retry-connection')
        } else if (
          error.response &&
          error.response.data &&
          error.response.status === 417 &&
          error.response.data.request_id
        ) {
          context.commit(
            'setPlumeLoginError',
            `Request failed. Request ID: ${error.response.data.request_id}`,
          )
        } else {
          context.commit('setPlumeLoginError', `Request failed`)
        }
      }
    },
    agreeConsent(context, data) {
      logUserAction({
        type: 'user_action',
        label: 'User Agreed to Terms and Conditions',
        data: { consent: data.consent }
      });

      console.log('data', data)
      context.state.consentAgreed = data.consent
      return new Promise((resolve) => {
        axios
          .post(
            '/index.php?controller=landingpage&action=post-register-user-consent&UserConsent=' +
              data.consent +
              '&wftkn=' +
              data.wftkn,
          )
          .then((res) => {
            logUserAction({
              type: 'api_response',
              label: 'User Consent Successfully Saved'
            });
            resolve()
          })
      })
    },
  },
})
